import React from "react";
import IMAGES from "../../constants/images";

export default function Index() {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full p-6">
      {/* Image */}
      <div className="mb-6 flex items-center justify-center">
        <img
          src={IMAGES.empty_stats}
          alt="Empty Analytics"
          className="w-50 opacity-80"
        />
      </div>
      {/* Text */}
      <p className="text-center text-[#334155] text-sm font-normal font-poppins">
        Once you start seeing patients, your session analytics will appear here.
      </p>
      <p className="text-center text-[#334155] text-sm font-normal font-poppins">
        Stay consistent to build insights on your care delivery.
      </p>
    </div>
  );
}
